
import { Component, Prop, Vue } from "vue-property-decorator";
import { dispatchSubmitWithdrawRequest } from "@/store/mlm/actions";
import { dispatchGetUserProfile } from "@/store/main/actions";
import { dispatchValidateDexnetAddress } from "@/store/mlm/actions";
import { readAppConfigs, readUserProfile } from "@/store/main/getters";
// import WarningModal from "@/components/Main/Transactions/WarningModal.vue";
@Component({
  components: {
    // WarningModal,
  },
})
export default class WithdrawalModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;

  public standart: string = "BEP20";
  public token: string = "USDT";
  public withdrawStep = 0;
  public withdrawAmount: any = 0.0;
  public withdrawConvertedAmount: any = 0.0;
  public withdrawFee: any = 0.0;
  public withdrawAddress = "";
  public withdrawSecurityCode = "";
  public withdrawAddressError: any = "";
  public withdrawAmountError: any = "";
  public withdrawSecurityCodeError: any = "";
  public secondsLeft = 180;
  public withdrawRequestUpdate = 10;
  public withdrawRequestId = null;
  public minDexnetWithdrawAmount = 5;
  // public withdrawRequestInfo: IWithdrawRequestInfo = {
  //   id: 0,
  //   paid_status: '',
  //   confirmed_by_email: false,
  //   confirmed_by_telegram: false,
  // };
  public isModalClosed: boolean = false;
  public loadingState: any = {
    submit: false,
  };

  public async mounted() {
    await dispatchGetUserProfile(this.$store);
    // if (this.userProfile) {
    //   this.userMailLink = this.userProfile.email.split('@')[1];
    // }
    // if (this.userProfile && !this.userProfile.tg_bot_connected) {
    //   this.withdrawStep = 3;
    // } else {
    this.withdrawStep = 1;
    // }
  }

  public calcWithdrawFee() {
    if (!this.withdrawAmount || Number(this.withdrawAmount) === 0) {
      return 0;
    }
    const minFee = Number(
      this.appConfigs.withdrawal_min_fee
        ? this.appConfigs.withdrawal_min_fee
        : 1
    );
    const fee = Number(
      Number(this.withdrawAmount) *
        (Number(
          this.token === "USDT" ? this.appConfigs.withdrawal_fee_percent : 1
        ) /
          100)
    ).toFixed(8);
    return Number(fee) > Number(minFee) ? fee : minFee;
  }

  public handleAmountInput(event: any) {
    let value = event.target.value;
    
    // Удаляем все символы кроме цифр и точки
    value = value.replace(/[^\d.]/g, '');
    
    // Ограничиваем одной точкой
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // После обработки множественных точек, снова разбиваем на части
    const finalParts = value.split('.');

    // Обработка ведущих нулей
    if (finalParts.length === 1) {
      // Без десятичной части: 01540 -> 1540, 000 -> 0
      finalParts[0] = finalParts[0].replace(/^0+(?=\d)/, '');
      if (finalParts[0] === '') {
        finalParts[0] = '0';
      }
      value = finalParts[0];
    } else if (finalParts.length === 2) {
      // С десятичной частью: 00.15 -> 0.15, 000.00 -> 0.00
      finalParts[0] = finalParts[0].replace(/^0+(?=\d)/, '');
      if (finalParts[0] === '' || /^0+$/.test(finalParts[0])) {
        finalParts[0] = '0';
      }

      // Ограничиваем двумя знаками после запятой
      if (finalParts[1].length > 2) {
        finalParts[1] = finalParts[1].substring(0, 2);
      }

      value = finalParts[0] + '.' + finalParts[1];
    }
    
    this.withdrawAmount = value;
    this.amountChange();
  }

  public amountChange() {
    this.withdrawFee = this.calcWithdrawFee();
    const minAmount =
      this.token === "USDT"
        ? Number(this.appConfigs.min_amount_for_withdraw_usd)
        : this.minDexnetWithdrawAmount;

    const amountNumber = Number(this.withdrawAmount);
    const feeNumber = Number(this.withdrawFee);

    if (!isNaN(amountNumber) && amountNumber >= Number(minAmount)) {
      const converted = amountNumber - (isNaN(feeNumber) ? 0 : feeNumber);
      this.withdrawConvertedAmount = converted > 0 ? converted.toFixed(2) : "0.00";
    } else {
      this.withdrawConvertedAmount = "0.00";
    }
  }

  public async validateWithdrawForm() {
    if (
      this.token === "USDT" &&
      this.userProfile &&
      this.userProfile.balances.units < this.withdrawAmount
    ) {
      this.withdrawAmountError = this.$t(
        "Amount is bigger than your available balance"
      );
      return false;
    }
    if (
      this.token === "X1_B" &&
      this.userProfile &&
      this.userProfile.balances.x1_b < this.withdrawAmount
    ) {
      this.withdrawAmountError = this.$t(
        "Amount is bigger than your available balance"
      );
      return false;
    }
    if (
      this.token === "X1" &&
      this.userProfile &&
      this.userProfile.balances.x1 < this.withdrawAmount
    ) {
      this.withdrawAmountError = this.$t(
        "Amount is bigger than your available balance"
      );
      return false;
    }
    // if (!this.userProfile || !this.userProfile.tg_bot_connected) {
    //   commitSetUserErrorAlert(this.$store, {show: true, text: this.$t('Connect telegram to your account in Profile to withdraw funds').toString()});
    //   setTimeout( async  () => {
    //     commitSetUserErrorAlert(this.$store, {show: false, text: ''});
    //   }, 4000);
    //   return false;
    // }

    this.withdrawAmountError =
      Number(this.withdrawAmount) <= 0
        ? this.$t("Amount must be more than zero")
        : "";
    this.withdrawAmountError =
      Number(this.withdrawAmount) < this.minDexnetWithdrawAmount &&
      (this.token === "X1" || this.token === "X1_B")
        ? this.$t(`Minimum amount is ${this.minDexnetWithdrawAmount} X`)
        : this.withdrawAmountError;

    this.withdrawAmountError =
      Number(this.withdrawAmount) <
        this.appConfigs.min_amount_for_withdraw_usd && this.token === "USDT"
        ? this.$t(
            `Minimum amount is ${this.appConfigs.min_amount_for_withdraw_usd} USDT`
          )
        : this.withdrawAmountError;

    this.withdrawAddressError =
      this.withdrawAddress === "" ? this.$t("Address cannot be empty") : "";
    // this.withdrawSecurityCodeError = this.withdrawSecurityCode === '' ?
    //     this.$t('Finance password cannot be empty') : '';
    /** TODO: Add check validation for X1 address */
    if (this.token === "X1" || this.token === "X1_B") {
      let response = await dispatchValidateDexnetAddress(
        this.$store,
        this.withdrawAddress
      );
      if (!response || response.status != 200) {
        this.withdrawAddressError = this.$t("Address is not valid");
      }
    }

    return !(
      this.withdrawAmountError ||
      this.withdrawAddressError ||
      this.withdrawSecurityCodeError
    );
  }

  public async handleWithdrawFunds() {
    if (await this.validateWithdrawForm() && !this.loadingState.submit) {
      this.loadingState.submit = true;
      const data = {
        amount: this.withdrawAmount,
        standart: this.standart,
        token: this.token,
        wallet_address: this.withdrawAddress,
        security_code: this.withdrawSecurityCode,
      };

      let response = await dispatchSubmitWithdrawRequest(this.$store, data);
      // console.log('response', response);
      this.loadingState.submit = false;

      if (response) {
        this.withdrawStep = 2;
      } else {
        this.withdrawSecurityCodeError = response.security_code
          ? response.security_code[0]
          : "";
        if (response.wallet_address) {
          this.withdrawAddressError = response.wallet_address
            ? response.wallet_address[0]
            : "";
        } else if (response.non_field_errors) {
          this.withdrawAddressError = response.non_field_errors
            ? response.non_field_errors[0]
            : "";
        }
        this.withdrawAmountError = response.amount ? response.amount[0] : "";
        this.$toast.error(this.$t("Error").toString());
      }
    }
  }

  public closeModal() {
    this.isModalClosed = true;
    this.$emit("close-modal", this.withdrawStep === 2);
  }

  // --- 02.12.2025
  public showWarningDexnetModal() {
    this.$emit('show-warning');
  }
  // --- 14.01.2026
  public handleSetTab(new_token: string){
    this.token = new_token;
    this.withdrawAmount = 0;
    this.amountChange();
  }
  public handleSetAllAmount() {
    let amount = 0;
    if(this.token === 'USDT'){
      amount = this.userProfile?.balances.units || 0;
    }
    if(this.token === 'X1' ){
      amount = this.userProfile?.balances.x1 || 0;
    }
    if(this.token === 'X1_B'){
      amount = this.userProfile?.balances.x1_b || 0;
    }
    this.withdrawAmount = Number(amount).toFixed(2);
    this.amountChange();
  }
 

  get userProfile() {
    return readUserProfile(this.$store);
  }
  get appConfigs() {
    return readAppConfigs(this.$store);
  }
}
